const axios = require("axios");

export const getNeoCurrencyToken = async () => {
  try {
    let requestUrl =
      "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/braintree-getNeoCurrencyToken";
    let result = await axios.post(requestUrl, {
      environment: process.env.REACT_APP_ENVIRONMENT,
    });
    if (result.status === 200) {
      return result.data;
    } else {
      return result;
    }
  } catch (err) {
    return err;
  }
};

export const getNeoCurrencyBrands = async ({ token }) => {
  try {
    let requestUrl =
      "https://us-central1-boltconcierge-2f0f9.cloudfunctions.net/braintree-getNeoCurrencyBrands";
    let result = await axios.post(requestUrl, {
      environment: process.env.REACT_APP_ENVIRONMENT,
      token,
    });
    if (result.status === 200) {
      return result.data;
    } else {
      return result;
    }
  } catch (err) {
    return err;
  }
};



// WEBPACK FOOTER //
// ./src/functions/RetailerPaymentHelper.js